import React, { useState, useEffect } from 'react';
import './InputRange.css';
import { forwardRef } from 'react';
//import "./InputSvg.css"
const InputRange = forwardRef(({ name, className, min, max, value,_setValue },ref) => {

    const [val, setVal] = useState(value ? value : "0");
    const changeValue = (e) =>{
        setVal(e.target.value)
        _setValue(name, e.target.value);
    }
    //const [value, setValue] = useState(valueDefault ? valueDefault : min + max / 2);
    return (
        <>
            { /* <span id="toolSvgRange">35</span> 
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 600 600">
                <defs>
                    <filter id="goo" colorInterpolationFilters="sRGB">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur"/>
                        <feColorMatrix in="blur" mode="matrix" defaultValue="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7" result="cm" />

                    </filter>
                </defs>
                <g id="dragGroup">
                    <path id="dragBar" fill="#808080" d="M447,299.5c0,1.4-1.1,2.5-2.5,2.5h-296c-1.4,0-2.5-1.1-2.5-2.5l0,0c0-1.4,1.1-2.5,2.5-2.5 h296C445.9,297,447,298.1,447,299.5L447,299.5z" />
                    <g id="displayGroup">
                        <g id="gooGroup" filter="url(#goo)">
                            <circle id="display" fill="#808080" cx="146" cy="299.5" r="16" />
                            <circle id="dragger" OnDrag={dragUpdate} fill="#808080" stroke="#03A9F4" strokeWidth="0" cx="146" cy="299.5" r="15" />

                        </g>
                        <text className="downText" x="146" y="304"></text>
                        <text className="upText" x="145" y="266"></text>
                    </g>


                </g>
            </svg>
            */}
            <input type="range" ref={ref} min={0} max={max} value={val} className={"input-range " + className} onChange={changeValue} />
        </>

    )
})
InputRange.defaultProps = {
    name: "input-range_default",
    className: "",
    min: "0",
    max: "5",
}

export default InputRange